import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28.571 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "27.571",
      height: "19",
      x: ".5",
      y: ".5",
      fill: "#fff",
      stroke: "#000",
      rx: "1.5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#ff5f00",
      d: "M16.706 13.931h-4.375V6.069h4.375z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#eb001b",
      d: "M12.608 10c0-1.595.747-3.015 1.91-3.93a5 5 0 1 0 0 7.862A5 5 0 0 1 12.608 10"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#f79e1b",
      d: "M22.607 10a5 5 0 0 1-8.09 3.931A4.99 4.99 0 0 0 16.428 10a4.99 4.99 0 0 0-1.91-3.93A5 5 0 0 1 22.608 10"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "mastercard"}) } }